












import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BpcCustomerAreaSettingForm from '@core/components/forms/customer-area-setting-form.vue';

@Component({
  name: 'bpc-customer-area-setting-page',
  components: {
    'bpc-page-title': PageTitle,
    BpcCustomerAreaSettingForm,
  },
})
export default class SuperadminOptionsPage extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  refreshPage() {
    this.$router.go(null);
  }
}
